module.exports = __webpack_public_path__ + "img/info_sp_25.64c5fde9.png";